import { diff } from 'json-diff'
import { formatter } from './'
import { authService, logService } from '../services'
import moment from 'moment'

export default {
  addFunder (id, changes) {
    saveLog('funder', id, 'add', changes)
  },
  updateFunder (id, before, after, exclude, fields, additional) {
    const changes = generateChanges(before, after, exclude, fields)

    if (changes !== '' || additional !== '') {
      saveLog('funder', id, 'update', (additional ? additional + ', ' : '') + changes)
    }
  },
  addFunderFundManager (id, changes) {
    saveLog('funder', id, 'add funder f. manager', changes)
  },
  updateFunderFundManager (id, changes) {
    saveLog('funder', id, 'update funder f. manager', changes)
  },
  removeFunderFundManager (id, changes) {
    saveLog('funder', id, 'delete funder f. manager', changes)
  },
  addFundManager (id, changes) {
    saveLog('fund-manager', id, 'add', changes)
  },
  updateFundManager (id, before, after, exclude, additional) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '' || additional !== '') {
      saveLog('fund-manager', id, 'update', (additional ? additional + ', ' : '') + changes)
    }
  },
  addClient (id, changes) {
    saveLog('client', id, 'add', changes)
  },
  updateClient (id, before, after, exclude, fields, additional) {
    const changes = generateChanges(before, after, exclude, fields)

    if (changes !== '' || additional !== '') {
      saveLog('client', id, 'update', changes + (additional ? (changes ? ', ' : '') + additional : ''))
    }
  },
  updateClientText (id, action, changes) {
    saveLog('client', id, action, changes)
  },
  addEmployee (id, changes) {
    saveLog('employee', id, 'add', changes)
  },
  updateEmployee (id, before, after, exclude, fields, additional) {
    const changes = generateChanges(before, after, exclude, fields)

    if (changes !== '' || additional !== '') {
      saveLog('employee', id, 'update', changes + (additional ? (changes ? ', ' : '') + additional : ''))
    }
  },
  updateEmployeeExtra (id, changes) {
    if (changes !== '') {
      saveLog('employee', id, 'update', changes)
    }
  },
  addJob (id, after, exclude, additional, fields) {
    const changes = generateNewSet(after, exclude, fields)
    if (changes !== '' || additional !== '') {
      saveLog('job', id, 'add', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateJob (id, before, after, exclude, additional, fields) {
    const changes = generateChanges(before, after, exclude, fields)

    if (changes !== '' || additional !== '') {
      const txt = (additional ? additional + ', ' : '') + changes
      saveLog('job', id, 'update', txt)

      return txt
    }

    return ''
  },
  updateJobExtra (id, action, changes) {
    saveLog('job', id, action, changes)
  },
  updateJobCostingPayroll (id, action, changes) {
    if (changes !== '') {
      saveLog('job', id, action, changes)
    }
  },
  updateJobFeedbackTimesheet (id, changes) {
    saveLog('job', id, 'update job feedback', changes)
  },
  cancelJob (id, changes) {
    saveLog('job', id, 'cancel', changes)
  },
  uncancelJob (id, changes) {
    saveLog('job', id, 'uncancel', changes)
  },
  addBaseJob (id, after, exclude, additional, fields) {
    const changes = generateNewSet(after, exclude, fields)
    if (changes !== '' || additional !== '') {
      saveLog('basejob', id, 'add', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateBaseJob (id, before, after, exclude, additional, fields) {
    const changes = generateChanges(before, after, exclude, fields)

    if (changes !== '' || additional !== '') {
      saveLog('basejob', id, 'update', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateBaseJobExtra (id, action, changes) {
    saveLog('basejob', id, action, changes)
  },
  cancelBaseJob (id, changes) {
    saveLog('basejob', id, 'cancel', changes)
  },
  uncancelBaseJob (id, changes) {
    saveLog('basejob', id, 'uncancel', changes)
  },
  addClientTask (id, changes) {
    saveLog('client', id, 'add task', changes)
  },
  updateClientTask (id, before, after, exclude) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('client', id, 'update task', changes)
    }
  },
  deleteClientTask (id, changes) {
    saveLog('client', id, 'delete task', changes)
  },
  addClientFunder (id, changes) {
    saveLog('client', id, 'add funder', changes)
  },
  updateClientFunder (id, before, after, exclude, additional) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '' || additional !== '') {
      saveLog('client', id, 'update funder', (additional ? additional + ', ' : '') + changes)
    }
  },
  deleteClientFunder (id, changes) {
    saveLog('client', id, 'delete funder', changes)
  },
  addClientFunding (id, changes) {
    saveLog('client', id, 'add funding', changes)
  },
  updateClientFunding (id, changes) {
    saveLog('client', id, 'update funding', changes)
  },
  deleteClientFunding (id, changes) {
    saveLog('client', id, 'delete funding', changes)
  },
  addClientBudget (id, changes) {
    saveLog('client', id, 'add budget', changes)
  },
  updateClientBudget (id, changes) {
    saveLog('client', id, 'update budget', changes)
  },
  deleteClientBudget (id, changes) {
    saveLog('client', id, 'delete budget', changes)
  },
  addClientFundingPeriod (id, changes) {
    saveLog('client', id, 'add funding period', changes)
  },
  updateClientFundingPeriod (id, changes) {
    saveLog('client', id, 'update funding period', changes)
  },
  deleteClientFundingPeriod (id, changes) {
    saveLog('client', id, 'delete funding period', changes)
  },
  addClientLeave (id, changes) {
    saveLog('client', id, 'add leave', changes)
  },
  updateClientLeave (id, before, after, exclude) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('client', id, 'update leave', changes)
    }
  },
  deleteClientLeave (id, changes) {
    saveLog('client', id, 'delete leave', changes)
  },
  addEmployeeLeave (id, changes) {
    saveLog('employee', id, 'add leave', changes)
  },
  updateEmployeeLeave (id, before, after, exclude) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('employee', id, 'update leave', changes)
    }
  },
  deleteEmployeeLeave (id, changes) {
    saveLog('employee', id, 'delete leave', changes)
  },
  sendEmailSingleJob (id, changes) {
    saveLog('job', id, 'send email', changes)
  },
  sendEmailBaseJob (id, changes) {
    saveLog('basejob', id, 'send email', changes)
  },
  addBlacklist (id, changes) {
    saveLog('client', id, 'blacklist carer', changes)
  },
  deleteBlacklist (id, changes) {
    saveLog('client', id, 'blacklist carer', changes)
  },
  addEmployeeFile (id, after, exclude, additional) {
    const changes = generateNewSet(after, exclude)

    if (changes !== '' || additional !== '') {
      saveLog('employee', id, 'add file', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateEmployeeFile (id, before, after, exclude, additional) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('employee', id, 'update file', (additional ? additional + ', ' : '') + changes)
    }
  },
  deleteEmployeeFile (id, changes) {
    saveLog('employee', id, 'delete file', changes)
  },
  addClientFile (id, after, exclude, additional) {
    const changes = generateNewSet(after, exclude)
    if (changes !== '' || additional !== '') {
      saveLog('client', id, 'add file', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateClientFile (id, before, after, exclude, additional) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('client', id, 'update file', (additional ? additional + ', ' : '') + changes)
    }
  },
  deleteClientFile (id, changes) {
    saveLog('client', id, 'delete file', changes)
  },
  addFunderFile (id, after, exclude, additional) {
    const changes = generateNewSet(after, exclude)
    if (changes !== '' || additional !== '') {
      saveLog('funder', id, 'add file', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateFunderFile (id, before, after, exclude, additional) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('funder', id, 'update file', (additional ? additional + ', ' : '') + changes)
    }
  },
  deleteFunderFile (id, changes) {
    saveLog('funder', id, 'delete file', changes)
  },
  addJobFile (id, after, exclude, additional) {
    const changes = generateNewSet(after, exclude)
    if (changes !== '' || additional !== '') {
      saveLog('job', id, 'add file', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateJobFile (id, before, after, exclude, additional) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('job', id, 'update file', (additional ? additional + ', ' : '') + changes)
    }
  },
  deleteJobFile (id, changes) {
    saveLog('job', id, 'delete file', changes)
  },
  addBaseJobFile (id, after, exclude, additional) {
    const changes = generateNewSet(after, exclude)
    if (changes !== '' || additional !== '') {
      saveLog('basejob', id, 'add file', (additional ? additional + ', ' : '') + changes)
    }
  },
  updateBaseJobFile (id, before, after, exclude, additional) {
    const changes = generateChanges(before, after, exclude)

    if (changes !== '') {
      saveLog('basejob', id, 'update file', (additional ? additional + ', ' : '') + changes)
    }
  },
  deleteBaseJobFile (id, changes) {
    saveLog('basejob', id, 'delete file', changes)
  },
  updateCustomIdentifier (id, module, changes) {
    if (changes !== '') {
      saveLog(module, id, 'update custom identifier', changes)
    }
  },
  generateNewItemChanges (values, excludes = []) {
    return generateNewSet(values)
  },
  generateItemChanges (item, values, excludes = [], fields = [], include = []) {
    return generateChanges(item, values, excludes, fields, include)
  },
  setEmployeeFileToggle (id, changes) {
    saveLog('employee', id, 'toggle', changes)
  },
  addFeedback (id, changes) {
    saveLog('feedback', id, 'add', changes)
  },
}

function saveLog (type, id, action, changes) {
  const currentUser = authService.getCurrentUser()
  const { id: userId, name } = currentUser

  logService.add({ type, type_id: id, action, updated_by: name, updated_by_id: userId, changes })
}

function generateChanges (item, values, excludes = [], fields = [], includes = []) {
  const result = diff(item, values)
  let changes = ''

  if (result) {
    for (const key of Object.keys(result)) {
      const value = result[key]
      const isExclude = excludes.findIndex(item => item === key)
      const isInclude = includes.findIndex(item => item === key)
      const isFound = fields.findIndex(item => item.key === key)
      // console.log('isExclude', isExclude)

      // if one field exists on both exclude and include list, include has higher priority
      if (isExclude < 0 || isInclude > -1) {
        if ((value !== null && value !== undefined) && value.hasOwnProperty('__new')) {
          // const label = formatter.capitalize(key.replace(/_/g, ' '))
          const label = isFound >= 0 ? fields[isFound].label : formatter.capitalize(key.replace(/_/g, ' '))
          // console.log('label: ', label)

          const oldValue = value.__old === null
            ? 'NULL'
            : value.__old === undefined
              ? 'UNDEFINED'
              : !isDate(value.__old)
                ? value.__old
                : showAsDateTime(key)
                  ? formatDateTime(value.__old)
                  : showAsTime(key)
                    ? formatTime(value.__old)
                    : formatDate(value.__old)
          const isOldValueEmpty = !(value.__old !== null && value.__old !== undefined)

          const newValue = value.__new === null
            ? 'NULL'
            : value.__new === undefined
              ? 'UNDEFINED'
              : !isDate(value.__new)
                ? value.__new
                : showAsDateTime(key)
                  ? formatDateTime(value.__new)
                  : showAsTime(key)
                    ? formatTime(value.__new)
                    : formatDate(value.__new)
          const isNewValueEmpty = !(value.__new !== null && value.__new !== undefined)
          const isDateValue = isDate(value.__old) || isDate(value.__new)

          /**
           * let A = isOldValueEmpty, B = isNewValueEmpty
           *   A    B    | result (isDifferent)
           * -------------------------------
           *   0    0    |  condition applied
           *   0    1    |        true
           *   1    0    |        true
           *   1    1    |        false
           */
          const isDifferent = isOldValueEmpty && isNewValueEmpty
            ? false
            : (isOldValueEmpty || isNewValueEmpty)
              ? true
              : !isDateValue
                ? value.__old.toString() !== value.__new.toString()
                : (showAsDateTime(key) || showAsTime(key))
                  ? !moment(value.__old).isSame(moment(value.__new))
                  : !moment(value.__old).isSame(moment(value.__new), 'day')

          if (isDifferent) {
            let ct = changes ? ', ' : ''
            const textBefore = ` from "${oldValue}"`
            const textAfter = ` to "${newValue}"`

            if (textBefore || textAfter) {
              changes += `${ct}${label}${textBefore}${textAfter}`
            }
          }

          // if (value.__old !== null && isDate(value.__old)) {
          //   // skip if no changes on date
          //   if (showAsDateTime(key)) {
          //     if (!moment(value.__old).isSame(moment(value.__new))) {
          //       changes += `${label} from "${formatDateTime(value.__old)}" to "${formatDateTime(value.__new)}", `
          //     }
          //   } else if (showAsTime(key)) {
          //     if (!moment(value.__old).isSame(moment(value.__new))) {
          //       changes += `${label} from "${formatTime(value.__old)}" to "${formatTime(value.__new)}", `
          //     }
          //   } else {
          //     if (!moment(value.__old).isSame(moment(value.__new), 'day')) {
          //       changes += `${label} from "${formatDate(value.__old)}" to "${formatDate(value.__new)}", `
          //     }
          //   }
          // } else {
          //   if ((value.__old !== null && value.__old !== undefined) && (value.__new !== null && value.__new !== undefined) && (value.__old.toString() !== value.__new.toString())) {
          //     changes += `${label} from "${value.__old}" to "${value.__new}", `
          //   } else if ((value.__old !== null && value.__old !== undefined) && (value.__new !== null && value.__new !== undefined)) {
          //     // changes += `${label} to "${isDate(value.__new) ? formatDate(value.__new) : value.__new}", `
          //     changes += `${label} to "${isDate(value.__new) ? (showAsDateTime(key) ? formatDateTime(value.__new) : formatDate(value.__new)) : value.__new}", `
          //   } else if (value.__new !== null && value.__new !== undefined) {
          //     changes += `${label} to "${isDate(value.__new) ? (showAsDateTime(key) ? formatDateTime(value.__new) : formatDate(value.__new)) : value.__new}", `
          //   }
          // }
        }
      }
    }
  }

  return changes
}

function generateNewSet (values, excludes = [], fields = [], includes = []) {
  let changes = ''
  for (const key of Object.keys(values)) {
    const value = values[key]
    const isExclude = excludes.findIndex(item => item === key)
    const isInclude = includes.findIndex(item => item === key)
    const isFound = fields.findIndex(item => item.key === key)

    // if one field exists on both exclude and include list, include has higher priority
    if (isExclude < 0 || isInclude > -1) {
      if (value !== null && value !== undefined) {
        const label = isFound >= 0 ? fields[isFound].label : formatter.capitalize(key.replace(/_/g, ' '))
        // check if the value is date
        if (isGMTDate(value)) {
          changes += `${label} to "${showAsDateTime(key) ? formatDateTime(value) : showAsTime(key) ? formatTime(value) : formatDate(value)}", `
        } else if (value !== false) {
          changes += `${label} to "${value}", `
        }
      }
    }
  }

  return changes.length > 0 ? changes.substr(0, changes.length - 2) : ''
}
/*
function isDate (date) {
  return date ? (date.toString().indexOf('Z') === date.toString().length - 1 || date.toString().indexOf('GMT') > -1) && moment(date).isValid() : false
}
 */
function isDate (date) {
  if (isGMTDate(date)) {
    return true
  }

  if (moment.isMoment(date)) {
    return true
  }

  if (date && isNaN(date) && date.length >= 10) {
    const dateCheck = new RegExp(/^\d{4}-\d{2}-\d{2}$/)
    return dateCheck.exec(date.substr(0, 10)) !== null
  }

  return false
}

function isGMTDate (date) {
  return date ? (date.toString().indexOf('GMT') > -1) && moment(date).isValid() : false
}

function formatDate (value) {
  const formatted = moment(value).format('DD/MM/YYYY')

  return formatted !== 'Invalid date' ? formatted : ''
}

function formatTime (value) {
  const formatted = moment(value).format('hh:mm A')

  return formatted !== 'Invalid date' ? formatted : ''
}

function formatDateTime (value) {
  const formatted = moment(value).format('DD/MM/YYYY hh:mm A')

  return formatted !== 'Invalid date' ? formatted : ''
}

function showAsDateTime (key) {
  return key === 'job_start_date' || key === 'job_end_date'
}

function showAsTime (key) {
  return key === 'job_start_time' || key === 'job_end_time' || key === 'start_datetime' || key === 'end_datetime' || key === 'custom_so_start_time' || key === 'custom_so_end_time'
}
